import CheckboxTnc from '../form/CheckboxTnc.js';
import SelectProductQty from '../form/SelectProductQty.js';

function PanelSelectProductQty(props) {
  const isRedPacketEvent = props.isRedPacketEvent ?? false;
  const step = isRedPacketEvent ? 4 : 3;
  const redPacketEventProductImageMapping = props.redPacketEventProductImageMapping ?? {};
  var remarks = props.remarks;
  var lang = props.lang;

const isStewPotEvent = props.isStewPotEvent ?? false;
const isPistachioEvent = props.isPistachioEvent ?? false;

  return (
    <div className="step">
        <p>步驟{step}：選擇預購指定數量(必填)</p>
        <SelectProductQty isRedPacketEvent={isRedPacketEvent} redPacketEventProductImageMapping={redPacketEventProductImageMapping} remarks={remarks} lang={lang} item_Details={props.item_Details} setItemQty={(Item_Code, value)=>props.setItemQty(Item_Code, value)} totalAmount={props.totalAmount} isShowScanInput={props.isShowScanInput} passClearSelectedItems={props.passClearSelectedItems} image_Generatation_Status={props.image_Generatation_Status} handlePreviewTask={props.handlePreviewTask}></SelectProductQty>
        {
            isStewPotEvent
            &&
            <span>
            <p className="warning"># 香港版 或 國內版只限預購一個 </p>
            <p className="warning">* 更「家」鮮燉盅(國內版)只限網上/門市預購，及直送郵寄國內，不設香港/澳門門市取貨。請於電子印花上的取貨期內到所選門市申報郵寄國內地址。閣下完成後，預計約5-10天收到預購產品(確實郵遞時間視乎收貨地區而定)。</p>
            </span>
            
        }
        {
            isPistachioEvent
            &&
            <span>
            <p className="warning" style={{backgroundColor: 'yellow', fontWeight: 'bold' }}>*香港包裝及內地包裝的原料同為美國開心果，僅包裝地不同，風味無異。預購成功後隨機發貨，不設揀貨。</p>
            </span>
            
        }
         <p className="warning">**一經成功付款，恕不能更改數量選擇</p>
    </div>
   );
 }
 
export default PanelSelectProductQty;